import { Route } from '@angular/router';
import { HomeComponent } from './home.component';

export const homeRoutes: Route[] = [
  { path: '', component: HomeComponent },
  { path: 'home', component: HomeComponent },
];
